// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1gSS3","card":"styles_card__2rsDd","tooltip":"styles_tooltip__36VEe","indicator":"styles_indicator__2PYoI"};